import {Model} from "@/models/model";

export const OPERATORS = {
    'equal': {
        label: 'Equals',
        value: 'equal',
    },
    'notEqual': {
        label: 'Is different',
        value: 'notEqual',
    },
    'greaterThan': {
        label: 'Greater than',
        value: 'greaterThan',
    },
    'greaterThanOrEqual': {
        label: 'Greater than or equal',
        value: 'greaterThanOrEqual',
    },
    'lowerThan': {
        label: 'Lower than',
        value: 'lowerThan',
    },
    'lowerThanOrEqual': {
        label: 'Lower than or equal',
        value: 'lowerThanOrEqual',
    },
    'empty': {
        label: 'Empty',
        value: 'empty',
        isUnary: true,
    },
    'notEmpty': {
        label: 'Not Empty',
        value: 'notEmpty',
        isUnary: true,
    },
    'in': {
        label: 'In',
        value: 'in',
    },
};

export class BranchCondition extends Model {
    static create() {
        return new BranchCondition({source: '', operator: '', value: ''});
    }
}
